<script>
import {ref} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {useRoute} from "vue-router";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import DatePicker from "vue3-persian-datetime-picker";

export default {
  name: "AddCarExpenses",
  components: {DatePicker, LoadingPage},
  setup() {

    let loading = ref(false)
    let action_page = ref(useRoute().params.action)
    let exp_id = useRoute().params.exp_id

    let my_cars = ref([])


    let data = ref({
      action: action_page.value,
      cars_id: null,
      date: null,
      title: '',
      price: '',
      description: '',
    })


    function get_cars() {
      loading.value = true
      FreeWorld.Heisenberg({action:'show'}, 'my_cars' , true).then((res)=>{
        loading.value = false
        my_cars.value = res.data

        if (action_page.value === 'edit' || action_page.value === 'show_detail') details_exp()

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , get_cars)
      })
    }
    get_cars()

    function details_exp() {
      loading.value = true
      FreeWorld.Heisenberg({action:'show_detail' , exp_id: exp_id} , 'car_expenses' , true).then((res)=>{
        loading.value = false
        data.value.cars_id = res.data.cars_id
        data.value.date = res.data.date
        data.value.description = res.data.description
        data.value.title = res.data.title
        data.value.price = res.data.price
      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , details_exp)
      })
    }

    function add_exp() {
      if (data.value.cars_id === null){Swals.Warning('لطفا خودرو مورد نظر خود را انتخاب کنید!'); return false}
      if (data.value.date === null){Swals.Warning('لطفا تاریخ مورد نظر خود را انتخاب کنید!'); return false}
      if (data.value.title.trim().length === 0){Swals.Warning('لطفا عنوان مخارج را وارد کنید!'); return false}
      if (data.value.price.length === 0){Swals.Warning('لطفا قیمت مخارج را وارد کنید!'); return false}
      if (action_page.value === 'edit') data.value.exp_id = exp_id

      loading.value = true
      FreeWorld.Heisenberg(data.value , 'car_expenses' , true).then((res)=>{
        loading.value = false
        if (res.data.status === 'ok'){
          Swals.Done('مخارج شما با موفقیت ثبت شد' , 'back')
        }else {
          Swals.Fault('متاسفانه مخارج شما ثبت نشد!')
        }
      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , add_exp)
      })
    }

    return {
      loading,
      my_cars,
      data,
      add_exp,
      action_page,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':''" class="bg-color-liner">
    <div style="height: 5rem" class="d-flex align-items-center p-4">
      <img onclick="window.history.back()" class="icon-size-1 rounded-pill ms-3" src="../assets/img/icon-back.svg" alt="">
      <p class="text-white font-bold font-4">ثبت مخارج خودرو</p>
    </div>

    <div id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">

      <div class="d-flex justify-content-between p-3 bg-custom rounded-pill shadow mb-4">
        <p class="font-4 text-color">انتخاب خودرو :</p>

        <select v-model="data.cars_id" :disabled="action_page === 'show_detail'" class="border-0 bg-custom w-65 text-center font-4">
          <option v-for="item in my_cars" :key="item.id" :value="item.id" class="font-5">{{ item.name }}</option>
        </select>
      </div>

      <div class="d-flex justify-content-between p-3 bg-custom rounded-pill shadow mb-4">
        <p class="font-4 text-color">تاریخ :</p>

        <date-picker :disabled="action_page === 'show_detail'" class="w-85" v-model="data.date"></date-picker>
      </div>

      <div class="d-flex justify-content-between p-3 bg-custom rounded-pill shadow mb-4">
        <p class="font-4 text-color">عنوان مخارج :</p>

        <input v-model="data.title" :disabled="action_page === 'show_detail'" class="w-65 border-0 bg-custom" type="text">
      </div>

      <div class="d-flex justify-content-between p-3 bg-custom rounded-pill shadow mb-4">
        <p class="font-4 text-color">قیمت (تومان) :</p>

        <input v-model="data.price" :disabled="action_page === 'show_detail'" class="w-60 border-0 bg-custom" type="tel" placeholder="لطفا از اعداد انگلیسی استفاده کنید">
      </div>

      <div class="p-3 bg-custom shadow rounded-4 mb-5">
        <p class="font-4 text-color mb-2">توضیحات دیگر :</p>
        <textarea v-model="data.description" :disabled="action_page === 'show_detail'" class="w-100 rounded-4 p-3 font-4" rows="3"></textarea>
      </div>

      <div v-if="action_page !== 'show_detail'" class="d-flex justify-content-center">
        <p  @click="add_exp" class="text-white font-bold rounded-pill bg-color text-center p-3 w-35 font-4 shadow-custom">ثبت</p>
      </div>
    </div>
  </div>

</template>

<style scoped>

</style>